/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventDto } from '../../models/event-dto';

export interface EventControllerFindAllV1$Params {

/**
 * 행사 상태 필터 (PENDING, ONGOING, FINISHED, CANCELLED)
 */
  status?: 'PENDING' | 'ONGOING' | 'FINISHED' | 'CANCELLED';

/**
 * 행사 타입 필터
 */
  type?: string;
}

export function eventControllerFindAllV1(http: HttpClient, rootUrl: string, params?: EventControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventDto>>> {
  const rb = new RequestBuilder(rootUrl, eventControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EventDto>>;
    })
  );
}

eventControllerFindAllV1.PATH = '/api/v1/event';
